// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1123":"c9c31a7d","1783":"c9c31a7d","3609":"c9c31a7d","4874":"c9c31a7d"}[chunkId] + ".chunk.css";
};